import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import { useSelector } from "react-redux";
import ErrorModal from "../../Components/Security/ErrorModal";
import BabyCountModal from "../../Components/Security/BabyCountModal";

const PregnancyDueDate = ({ handleSubmit, creationData,prevStep, handleChange, formData, isLastStep, nextStep,isSubmitting,error,setErrors,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();
  const [pregnancyType, setPregnancyType] = useState(formData.pregnancyType || "");
  const [enrolled, setEnrolled] = useState(null); // To store enrolled status
  const [address, setAddress] = useState(""); // To store the returned address
  const [selectedDate, setSelectedDate] = useState(null);
  const [secondaryDate, setSecondaryDate] = useState(null); 
  const [selectedOption, setSelectedOption] = useState("");
  const [updatedAddress, setUpdatedAddress] = useState("");
  const [dueDateError, setDueDateError] = useState("");
  const [menstruationDateError, setMenstruationDateError] = useState("");
  const userData = useSelector((state) => state.userData);
  const contract = useSelector((state) => state.userData);
  const token = localStorage.getItem("AccessToken");
  const [errorMessage, setErrorMessage] = useState("");
  const [showBabyCountModal, setShowBabyCountModal] = useState(false);
  const minDate = new Date(new Date().setDate(new Date().getDate() + 1));
  const maxDate = new Date(new Date().setFullYear(new Date().getFullYear() + 50));

  useEffect(() => {
    // API call to get enrollment status and address - runs only on initial load
    const fetchEnrollmentData = async () => {
      const params = {
        memberID: contract.userData.MemberID || creationData.MemberID || "" ,
        firstName: contract.userData.FirstName || creationData.FirstName,
        dob: contract.userData.DOB || creationData.DOB,
        EmailID: contract.userData.EmailID || creationData.EmailID,
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        contract: contract.userData.ContractIdentified || creationData.ContractIdentified ||"",
        lastName: contract.userData.LastName || creationData.LastName,
      };
      try {
        const response = await axios.post(
          Endpoints.VerifyWINcentiveWelcomeBoxAddress,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        const { enrolled, address } = response.data;

        setEnrolled(enrolled);
        if (enrolled === "Y") {
          handleChange({ target: { name: "enrolled", value: enrolled } });
          setAddress(address);
        }
      } catch (error) {
        console.error("Error fetching enrollment data:", error);
        setEnrolled("N"); // Default to non-enrolled if the API call fails
        handleChange({ target: { name: "enrolled", value: "N" } });
      }
    };

    fetchEnrollmentData();
  }, []); // Empty dependency array ensures this only runs once on initial render

  useEffect(() => {
    if (formData.PregnancyDueDate) {
      setSelectedDate(new Date(formData.PregnancyDueDate));
    }
    if (formData.LastMenstrualPeriodDate) {
      setSecondaryDate(new Date(formData.LastMenstrualPeriodDate));
    }
    if (formData.WinCentiveAddress) {
      setUpdatedAddress(formData.WinCentiveAddress);
    }
    if (formData.addressOption) {
      setSelectedOption(formData.addressOption);
    }
    if (formData.pregnancyType) {
      setPregnancyType(formData.pregnancyType);
    }
  
  }, [formData]);

  useEffect(() => {
    debugger
    if ((userData.userData.BabyCountFlag === "Y") || (creationData.BabyCountFlag === "Y")) {
      setShowBabyCountModal(true);
    }
  }, [userData.BabyCountFlag, creationData]);

  const handleOptionChange = (e) => {

    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.addressOption; // Remove only the addressOption error

      // If "No" is selected, ensure validation exists for WinCentiveAddress
      if (selectedValue === "No" && !updatedAddress.trim()) {
          updatedErrors.WinCentiveAddress = "Address is required if 'No' is selected.";
      }

      return updatedErrors;
  });

    if (selectedValue === "Yes") {
      setUpdatedAddress(""); // Clear any existing input
      handleChange({ target: { name: "WinCentivekit", value: "Y" } });
      handleChange({ target: { name: "WinCentiveAddress", value: address || "" } }); // Use the original address
    } else if (selectedValue === "No") {
      setUpdatedAddress(""); // Allow input for a new address
      handleChange({ target: { name: "WinCentivekit", value: "Y" } });
      handleChange({ target: { name: "WinCentiveAddress", value: "" } }); // Clear the formData address until updated
    } else if (selectedValue === "Later") {
      setUpdatedAddress(""); // Clear any existing input
      handleChange({ target: { name: "WinCentivekit", value: "N" } });
      handleChange({ target: { name: "WinCentiveAddress", value: "" } }); // Clear the address
    }

    handleChange({ target: { name: "addressOption", value: selectedValue || "" } });
  };

  const handleAddressChange = (e) => {
    const updatedValue = e.target.value;
    if (updatedValue.length === 1 && updatedValue.trim() === "") {
      return;
    }
    setUpdatedAddress(updatedValue);
    handleChange({ target: { name: "WinCentiveAddress", value: updatedValue } });

    setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };

        // Keep the error if "No" is selected and the address is empty
        if (selectedOption === "No" && !updatedValue.trim()) {
            updatedErrors.WinCentiveAddress = "Address is required if 'No' is selected.";
        } else {
            delete updatedErrors.WinCentiveAddress; // Remove error if valid address is entered
        }

        return updatedErrors;
    });
};

const handlePregnancyTypeChange = (e) => {
  const value = e.target.value;
  setPregnancyType(value);

  // If "I'm pregnant" is selected, set IsPregnant to "Y", otherwise "N"
  handleChange({ target: { name: "pregnancyType", value } });
  handleChange({ target: { name: "IsPregnant", value: value === "I'm pregnant" ? "Y" : "N" } });

  setErrors((prevErrors) => {
    const updatedErrors = { ...prevErrors };
    delete updatedErrors.pregnancyType; // Remove error if a value is selected
    return updatedErrors;
  });
};

  // Handle date selection for Due Date
  const handleDueDateChange = (date) => {
    setSelectedDate(date);
    setSecondaryDate(null);
    handleChange({ target: { name: "PregnancyDueDate", value: date ? date.toLocaleDateString("en-US") : "" } });
    handleChange({ target: { name: "LastMenstrualPeriodDate", value: "" } });
    handleChange({ target: { name: "NoDueDateFlag", value: "N" } });

    if (enrolled === "N") {
      handleChange({ target: { name: "WinCentivekit", value: "N" } });
    }
    setErrorMessage("");
    setDueDateError("");
  };

  // Handle date selection for Last Menstruation Date
  const handleSecondaryDateChange = (date) => {
    setSecondaryDate(date);
    setSelectedDate(null);
    handleChange({ target: { name: "LastMenstrualPeriodDate", value: date ? date.toLocaleDateString("en-US") : "" } });
    handleChange({ target: { name: "PregnancyDueDate", value: "" } });
    if (enrolled === "N") {
      handleChange({ target: { name: "WinCentivekit", value: "N" } });
    }
    handleChange({ target: { name: "NoDueDateFlag", value: "Y" } });
    setErrorMessage("");
    setMenstruationDateError("");
  };


  return (
    <>
      <div className="step-section">
        <h3 className="page-heading-secondary-black-500 mb-4">{t("duedatetitle")}</h3>
        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            id="pregnant"
            name="pregnancyType"
            value="I'm pregnant"
            className="form-check-input radio-btn win-form-check-input"
            onChange={handlePregnancyTypeChange}
            checked={pregnancyType === "I'm pregnant"}
          />
          <label className="multistep-form-radio-checkbox-label" htmlFor="pregnant">
            {t("pregnantRadio")}
          </label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            id="surrogatePregnant"
            name="pregnancyType"
            value="My surrogate is pregnant"
            className="form-check-input radio-btn win-form-check-input"
            onChange={handlePregnancyTypeChange}
            checked={pregnancyType === "My surrogate is pregnant"}
          />
          <label className="multistep-form-radio-checkbox-label" htmlFor="surrogatePregnant">
            {t("surrogateRadio")}
          </label>
        </div>

        {!pregnancyType && error && <p className="text-danger">{"Please select atleast one option."} </p>}

        <label className="form-label win-form-label">{t("selectdate")} :</label>
        <DatePicker
          selected={selectedDate}
          dateFormat="MM/dd/yyyy"
          className="form-control win-form-control mobile-view calendar-control mb-4"
          id="due-date"
          onChange={handleDueDateChange}
          placeholderText="MM/DD/YYYY"
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={50}
          minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
          maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 50))}
          autoComplete="off"
          onKeyDown={(e) => e.preventDefault()}
        />
        {errorMessage && <p className="text-danger">{errorMessage}</p>}

        <p classname="mb-4"><strong>{t("lastmensruationdate")}</strong></p>
        
        <label className="form-label win-form-label">{t("selectLastMenstrualPeriodDate")} :</label>
        <DatePicker
          selected={secondaryDate}
          dateFormat="MM/dd/yyyy"
          className="form-control win-form-control mobile-view calendar-control mb-2"
          id="secondary-date"
          onChange={handleSecondaryDateChange}
          placeholderText="MM/DD/YYYY"
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={50}
          autoComplete="off"
          minDate={null}
          maxDate={new Date()}
          onKeyDown={(e) => e.preventDefault()}
        />
        {(!secondaryDate && !selectedDate) && error && <p className="text-danger">{"Please select either a Due Date or Last Menstruation Date."}</p>}
      </div>
      {/* <p>{t("notyetpregnant")}</p> */}
      <p><strong>Not pregnant yet?</strong> We're here to support you on your journey. Tap the back button to select I want family-building support.</p>
      {
      // enrolled === "Y" && (
      //   <div className="mt-4">

      //     {/* <p>{t("duedatewelcometext")}</p> */}
      //     <p><strong className="text-primary-color">Welcome to WINMaternity!</strong> We would love to send you gift some goodies for your pregnancy journey as well as a smart blood pressure cuff that you can sync upwith your WINFamily app to keep in touch with your health.</p>

      //     <p>{t("adresstitle")}</p>
      //     <p><strong>{address}</strong></p>

      //     <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
      //       <input
      //         type="radio"
      //         id="optionYes"
      //         name="addressOption"
      //         value="Yes"
      //         className="form-check-input radio-btn win-form-check-input"
      //         onChange={handleOptionChange}
      //         checked={selectedOption === "Yes"}
      //       />
      //       <label className="multistep-form-radio-checkbox-label" htmlFor="optionYes">
      //         {t("yesradio")}
      //       </label>
      //     </div>

      //     <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
      //       <input
      //         type="radio"
      //         id="optionNo"
      //         name="addressOption"
      //         value="No"
      //         className="form-check-input radio-btn win-form-check-input"
      //         onChange={handleOptionChange}
      //         checked={selectedOption === "No"}
      //       />
      //       <label className="multistep-form-radio-checkbox-label" htmlFor="optionNo">
      //         {t("noradio")}
      //       </label>
      //     </div>

      //     <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
      //       <input
      //         type="radio"
      //         id="optionLater"
      //         name="addressOption"
      //         value="Later"
      //         className="form-check-input radio-btn win-form-check-input"
      //         onChange={handleOptionChange}
      //         checked={selectedOption === "Later"}
      //       />
      //       <label className="multistep-form-radio-checkbox-label" htmlFor="optionLater">
      //         {t("noneradio")}
      //       </label>
      //     </div>

      //     {selectedOption === "No" && (
      //       <div className="mt-3">
      //         <label className="form-label" htmlFor="updatedAddress">
      //           {t("updatedAddress")}
      //         </label>
      //         <textarea
      //           id="updatedAddress"
      //           className="win-form-control textarea-control-w-100"
      //           rows="3"
      //           maxLength={250}
      //           value={updatedAddress}
      //           onChange={handleAddressChange}
      //         />
      //       {!updatedAddress && error && <p className="text-danger">{"Address is required if 'No' is selected."}</p>}

      //       </div>
      //     )}
      //     {!selectedOption && error && <p className="text-danger">{"Please select an address option."}</p>}
      //   </div>
      // )
      }

      <div className="mt-5 mb-5">
      {isHighmarkPortal ? (
          <div className="pagination-wrapper mt-5">
            <button className="previous-btn" onClick={prevStep}></button>
            <span className="me-3">{step} of {totalSteps}</span>
            <button className="next-btn" onClick={nextStep}></button>
          </div>
        ) : (
          <div className="mt-5">
            <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>{t('back')}</button>
            <button className="win-btn-primary mobile-view" onClick={nextStep}>{t('next')}</button>
          </div>
        )}
        </div>

        <BabyCountModal
          show={showBabyCountModal}
          onSelect={(count) => {
            setShowBabyCountModal(false);
            handleChange({ target: { name: "BabyCount", value: String(count) } });
          }}
          onClose={() => setShowBabyCountModal(false)}
        />
      <ErrorModal
        show={false}
        message={""}
        onClose={() => {}}
        closeButton={true}
      />
    </>
  );
};

export default PregnancyDueDate;
